import React from "react"
import Dialog from "material-ui/Dialog"
import FlatButton from "material-ui/FlatButton"
import strings from "../../../localization/strings"
import autobind from "class-autobind"
import { ELanguage, IAgreement } from "../../../models"
import { grey900 } from "material-ui/styles/colors"
import { Editor } from "react-draft-wysiwyg"
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"
import { EditorState, convertToRaw, ContentState } from "draft-js"
import draftToHtml from "draftjs-to-html"
import htmlToDraft from "html-to-draftjs"
import _ from "lodash"
import LanguageSelector from "../../language/LanguageSelector"
import he from "he"

interface IProps {
    existingLanguages: ELanguage[]
    editAgreement: IAgreement
    handleClose(): void
    handleSave(agreement: IAgreement): void
}
interface IState {
    language: ELanguage
    agreementHTML: string
    editorState: any
}

export default class AddAgreementTextDialog extends React.Component<IProps, IState> {
    private editor
    constructor(props: IProps) {
        super(props)
        const decodedAgreement = props.editAgreement && props.editAgreement.AgreementText && he.decode(props.editAgreement.AgreementText)
        const contentBlock = props.editAgreement && props.editAgreement.AgreementText && htmlToDraft(decodedAgreement)
        this.state = {
            language: props.editAgreement ? props.editAgreement.Language : null,
            agreementHTML: props.editAgreement && props.editAgreement.AgreementText ? decodedAgreement : "<p></p>\n",
            editorState: props.editAgreement && props.editAgreement.AgreementText && contentBlock ?
                EditorState.createWithContent(ContentState.createFromBlockArray(contentBlock.contentBlocks)) :
                EditorState.createEmpty(),
        }
        autobind(this)
    }

    componentDidMount() {
        this.editor.focus()
    }

    render() {
        const saveDisabled = this.state.agreementHTML.replace(/&nbsp;/g, "") === "<p></p>\n" || this.state.language === null || this.state.language === undefined
        return (
            <Dialog
                open
                autoScrollBodyContent
                title={strings.Agreement_Text}
                actions={[
                    <FlatButton
                        data-intercom-target={"AgreementTextDialog-Btn-Close"}
                        label={strings.CANCEL}
                        secondary
                        onTouchTap={this.props.handleClose}
                    />,
                    <FlatButton
                        data-intercom-target={"AgreementTextDialog-Btn-Save"}
                        label={strings.Save}
                        primary
                        disabled={saveDisabled}
                        onTouchTap={() =>
                            this.props.handleSave({ Language: this.state.language, AgreementText: this.state.agreementHTML })
                        }
                    />
                ]}
            >
                <div style={{ marginBottom: 10 }}>
                    <LanguageSelector
                        existingLanguages={this.props.existingLanguages}
                        selectedLanguage={this.state.language}
                        readonly={this.props.editAgreement ? true : false}
                        handleChange={language => this.setState({ language })}
                        label={strings.Language}
                        error={(this.state.language === null || this.state.language === undefined) && strings.This_field_is_required}
                    />
                </div>
                <Editor
                    editorRef={elem => this.editor = elem}
                    editorState={this.state.editorState}
                    editorStyle={{ minHeight: 300, border: "1px solid #F1F1F1", borderRadius: 2, color: grey900 }}
                    toolbarStyle={{ color: grey900 }}
                    onEditorStateChange={editorState => this.setState({ editorState, agreementHTML: draftToHtml(convertToRaw(editorState.getCurrentContent())) })}
                    toolbar={
                        {
                            options: ["inline", "blockType", "fontSize", "fontFamily", "list", "textAlign", "colorPicker", "link", "history"],
                            inline: {
                                options: ["bold", "italic", "underline", "strikethrough", "monospace"]
                            },
                            list: {
                                options: ['unordered', 'ordered']
                            }
                        }
                    }
                />
            </Dialog>
        )
    }
}
